const API = {
    V3: {
        accept: { 'Accept': 'application/vnd.api+json; version=3' },
        get: 'GET',
        post: 'POST',
        patch: 'PATCH',
        put: 'PUT',
        delete: 'DELETE',
        methodBase: function(method) {
            return {
                method: method,
                headers: this.accept,
                contentType: 'application/json'
            }
        },
        typeAttr: function(type, attrs) {
            return {
               type: type,
               attributes: attrs
            }
        },
        buildIncludes: function(incl) {
            if (incl !== undefined) {
                var inclAttrs = [incl].flat();
                var included;

                if (inclAttrs.length > 0) {
                    included = [];

                    for (var i = 0; i < inclAttrs.length; i++) {
                        included.push(this.typeAttr(inclAttrs[i].type, inclAttrs[i].attrs));
                    }
                }

                return included
            }
        },
        buildRelationships: function(rel) {
            if (rel !== undefined) {
                var relationships = {};

                for (var key in rel) {
                    if (rel.hasOwnProperty(key)) {
                        if (Array.isArray(rel[key])) {
                            relationships[key] = {
                                data: rel[key].map(item => ({
                                    id: item.id,
                                    type: item.type
                                }))
                            };
                        } else {
                            relationships[key] = {
                                data: {
                                    id: rel[key].id,
                                    type: rel[key].type
                                }
                            };
                        }
                    }
                }

                return relationships;
            }
        },
        stringify: function(jsonData) {
            return JSON.stringify(jsonData, function (key, value) {
                                             // replace all keys with `_` to `-` for JSONAPI format
                                             if (value && Object.prototype.toString.call(value) === '[object Object]') {
                                               var replacement = {};
                                               for (var k in value) {
                                                 if (Object.hasOwnProperty.call(value, k)) {
                                                   replacement[k.replace(/_/g,'-')] = value[k];
                                                 }
                                               }
                                               return replacement;
                                             }
                                             return value;
                                           })
        },
        apiProcessData: function(method, type, attrs, incl, rel, additionalData) {
            var data = {
                type: type,
                attributes: attrs
            };
            if (rel) {
                data.relationships = rel;
            }
            var requestData = {
                data: data
            };
            if (incl) {
                requestData.included = incl;
            }
            if (requestData.data && additionalData) {
                Object.assign(requestData.data, additionalData);
            }
            return $.extend(this.methodBase(method), {
                data: this.stringify(requestData)
            });
        },
        abnUniquenessGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/id_check/abn/check_uniqueness?' + 'number=' + attrs.number
            })
        },
        addressCreate: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'address', attrs), {
                url: '/users/addresses/'
            })
        },
        addressGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/users/addresses'
            })
        },
        businessGet: function(attrs) {
            var url = '/users/business?' + 'include=capped_membership,job_filter,job_filter.schedule,hubspot_sales_agent,membership.active_pending_downgrade,pricing,payment_type_preference,user,feedback_score,profile_completion'
            if (attrs && attrs.identityRenewalModalContext) {
                url += '&identity_renewal_modal_context=' + encodeURIComponent(attrs.identityRenewalModalContext)
            }
            return $.extend(this.methodBase(this.get), {
                url: url
            })
        },
        businessLogoDelete: function(attrs) {
            return $.extend(this.apiProcessData(this.delete), {
                url: '/users/business/destroy_logo'
            })
        },
        businessLogoUpdate: function(attrs) {
            return $.extend(this.methodBase(this.patch), {
                url: '/users/business',
                processData: false,
                contentType: false,
                cache: false,
                data: attrs
            })
        },
        businessPaymentTypePreferenceCreate: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'paymentType', attrs), {
                url: '/businesses/payment_type_preferences'
            })
        },
        businessPricingCreate: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'pricing', attrs), {
                url: '/businesses/pricing'
            })
        },
        businessPricingDelete: function() {
            return $.extend(this.apiProcessData(this.delete), {
                url: '/businesses/pricing'
            })
        },
        businessAwardCreate: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'award', attrs), {
                url: '/businesses/awards'
            })
        },
        businessAwardDelete: function(awardId) {
            return $.extend(this.apiProcessData(this.delete), {
                url: '/businesses/awards/' + awardId
            })
        },
        businessProfileCompletionCreate: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'profileCompletion', attrs), {
                url: '/businesses/profile_completions'
            })
        },
        businessUpdate: function(attrs) {
            return $.extend(this.apiProcessData(this.patch, 'business', attrs), {
                url: '/users/business/'
            })
        },
        checkGrammarSpellingGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/ai/check_grammar_spelling?' + 'text=' + attrs.text
            })
        },
        discardedLeadsGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/leads/discarded?' + 'include=sub_categories,suburb,user' +
                     '&page[number]=' + attrs.page + '&sort=' + attrs.sort +
                     '&q=' + (attrs.keyword || '')
            })
        },
        eoisGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/businesses/eois/' + '?include=job,job.user,job.suburb,job.sub_categories' +
                     '&page[number]=' + attrs.page + '&page[size]=' + attrs.size +
                     '&sort=' + attrs.sort + '&filter[status]=' + attrs.status +
                     '&q=' + (attrs.keyword || '')
            })
        },
        eoiUpdate: function(attrs, eoiId) {
            return $.extend(this.apiProcessData(this.patch, 'eoi', attrs), {
                url: '/eois/' + eoiId
            })
        },
        userSession: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'user-sessions', attrs), {
                url: '/users/sign_in'
            })
        },
        userGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/users/' + attrs.id
            })
        },
        userUpdate: function(attrs, userId, options) {
            var url = '/users/' + userId
            options = options || {}

            if (options.forcePhoneVerificationReset) {
                url += '?force_phone_verification_reset=true'
            }

            return $.extend(this.apiProcessData(this.patch, 'users', attrs), {
                url: url
            })
        },
        userCreate: function(attrs, incl) {
            return $.extend(this.apiProcessData(this.post, 'users', attrs, this.buildIncludes(incl)), {
                url: '/users'
            })
        },
        jobCreate: function(fullJsonData) {
            return $.extend(this.methodBase(this.post), {
                data: this.stringify(fullJsonData),
                url: '/jobs'
            })
        },
        prePostJobCheck: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/jobs/pre_post_job_check?sub_category_id=' + attrs['subCategoryId'] + '&suburb_id=' + attrs['suburbId']
            })
        },
        build: {
            attachment: function(opts) {
                return {
                    data: {
                        type: 'attachments',
                        relationships: {
                            job: {
                                data: {
                                    type: 'jobs',
                                    id: opts.jobId
                                }
                            }
                        }
                    }
                }
            }
        },
        attachment: function(opts) {
            return $.extend(this.methodBase(this.post), {
                url: '/attachments',
                processData: false,
                contentType: false,
                data: opts.data
            })
        },
        eoiCreate: function(attrs, incl, rel, meta) {
            var requestData = {
                data: { type: 'eois', attributes: attrs, relationships: this.buildRelationships(rel) },
                included: this.buildIncludes(incl),
                meta: meta
            }
            return $.extend(this.methodBase(this.post), {
                data: this.stringify(requestData),
                url: '/eois?include=user'
            })
        },
        leadViewedCreate: function(leadId) {
            return $.extend(this.methodBase(this.post), {
                url: '/leads/' + leadId + '/viewed'
            })
        },
        leadDelete: function(leadId) {
            return $.extend(this.methodBase(this.delete), {
                url: '/leads/' + leadId
            })
        },
        messageUnsend: function(messageId) {
            return $.extend(this.methodBase(this.patch), {
                url: '/messages/' + messageId + '/delete'
            })
        },
        eoiDiscardAsBusiness: function(eoiId) {
            return $.extend(this.methodBase(this.put), {
                url: '/eois/' + eoiId + '/discard_as_business'
            })
        },
        eoiTemplatesGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/businesses/' + attrs.businessId + '/eoi_templates' +
                     '?page[number]=' + attrs.page + '&page[size]=' + attrs.size
            })
        },
        eoiTemplateCreate: function(attrs, businessId) {
            return $.extend(this.apiProcessData(this.post, 'eoi_templates', attrs), {
                url: '/businesses/' + businessId + '/eoi_templates'
            })
        },
        excludedMatchUpdate: function(attrs, additionalData) {
            return $.extend(this.apiProcessData(this.patch, 'excludedMatch', attrs, null, null, additionalData), {
                url: '/job_filters/excluded_match/'
            })
        },
        generateEoiIntroGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/users/business/generate_eoi_intro' + '?job_id=' + attrs.jobId
            })
        },
        generateDescriptionGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/users/business/generate_description'
            })
        },
        jobClosureDataGet: function() {
            return $.extend(this.methodBase(this.get), {
                url: '/jobs/closure_data',
                async: false
            })
        },
        jobsPostingProgressCreate: function(data, cb) {
            $.ajax($.extend(this.methodBase(this.post), {
                url: window.App.url + '/jobs_posting_progress',
                data: data,
                processData: false
            })).always(cb)
        },
        jobAttachmentsGet: function(attrs) {
            return $.extend(this.apiProcessData(this.get), {
                url: '/jobs/' + attrs['jobId'] + '/attachments'
            })
        },
        jobPriceTypesGet: function(attrs) {
            return $.extend(this.apiProcessData(this.get), {
                url: '/jobs/' + attrs['jobId'] + '/price_types'
            })
        },
        jobFilterGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/businesses/job_filter'
            })
        },
        jobFilterUpdate: function(attrs) {
            return $.extend(this.apiProcessData(this.patch, 'jobFilter', attrs), {
                url: '/businesses/job_filter/'
            })
        },
        jobFilterUpdateSchedule: function(attrs) {
            return $.extend(this.apiProcessData(this.patch, 'job_filter_schedules', attrs), {
                url: '/businesses/job_filter/update_schedule'
            })
        },
        leadsAnalysisGet: function(attrs) {
            let url = '/leads/analysis?date_range=' + attrs.dateRange + '&statuses=' + attrs.statuses;

            if (attrs.startDate) {
                url += '&start_date=' + attrs.startDate;
            }

            if (attrs.endDate) {
                url += '&end_date=' + attrs.endDate;
            }

            return $.extend(this.methodBase(this.get), {
                url: url
            });
        },
        leadGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/leads/' + attrs.leadId + '?include=attachments,sub_categories,suburb,user'
            })
        },
        leadsGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/leads?' + 'include=sub_categories,suburb,user' + '&page[number]=' +
                     attrs.page + '&sort=' + attrs.sort + '&pinned_lead_id=' + (attrs.pinnedLeadId || '') +
                     '&extended_range=' + (attrs.extendedRange || '') +
                     '&q=' + (attrs.keyword || '')
            })
        },
        directQuoteRequestsGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/direct_quote_requests?' + 'include=job,job.user,job.suburb,job.sub_categories,eoi,eoi.jobs_conversation' +
                     '&page[number]=' + attrs.page + '&page[size]=' + attrs.size +
                     '&sort=' + attrs.sort + '&filter[column]=' + attrs.column +
                     '&q=' + (attrs.keyword || '')
            })
        },
        feedbackRequestCreate: function(attrs, eoiId) {
            return $.extend(this.apiProcessData(this.post, 'feedback', attrs), {
                url: '/feedback/feedback/' + eoiId
            })
        },
        fetchCappedMembershipDetailsGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/users/business/fetch_capped_membership_details?' + 'subCategoryIds=' + attrs.subcategoryIds + '&radius=' + attrs.radius + '&suburbId=' + attrs.suburbId
            })
        },
        forgotPassword: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'forgot-password', attrs), {
                url: '/users/forgot_password'
            })
        },
        userCheckEmail: function(email) {
            return $.extend(this.methodBase(this.get), {
                data: { email: email },
                url: '/users/check_email'
            })
        },
        userPinSend: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'user-pins', attrs), {
                url: '/users/send_pin'
            })
        },
        userPinValidate: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'user-pins', attrs), {
                url: '/users/validate_pin'
            })
        },
        userPasswordReset: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'users', attrs), {
                url: '/users/reset_password'
            })
        },
        phoneVerificationGenerate: function() {
            return $.extend(this.methodBase(this.get), {
                url: '/phone_verifications/generate'
            })
        },
        phoneVerificationSkip: function() {
            return $.extend(this.methodBase(this.post), {
                url: '/phone_verifications/skip'
            })
        },
        phoneVerificationVerify: function(attrs) {
            return $.extend(this.methodBase(this.post), {
                data: JSON.stringify({ data: { code: attrs.code } }),
                url: '/phone_verifications/verify'
            })
        },
        notificationsGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/notifications?' + '&page[number]=' + attrs.page + '&recipient_type=' + (attrs.recipientType || '')
            })
        },
        notificationsUpdate: function(attrs) {
            return $.extend(this.apiProcessData(this.patch, 'notifications', attrs), {
                url: '/notifications/' + attrs.notificationId + '/mark_as_read'
            })
        },
        recalculateCappedMembershipGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/users/business/recalculate_capped_membership_settings?' + 'excludedSubcategoryIds=' + attrs.excludedSubcategoryIds + '&excludedSuburbIds=' + attrs.excludedSuburbIds
            })
        },
        selfReportHireCreate: function(attrs, eoiId) {
            return $.extend(this.apiProcessData(this.post, 'eoi', attrs), {
                url: '/eois/' + eoiId + '/self_report'
            })
        },
        suburbFind: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/suburbs/' + attrs.id
            })
        },
        suburbsGet: function(query) {
            return $.extend(this.methodBase(this.get), {
                data: query,
                url: '/suburbs'
            })
        },
        categoriesGet: function(query) {
            return $.extend(this.methodBase(this.get), {
                data: query,
                url: '/categories'
            })
        },
        subCategoriesGet: function(query) {
            return $.extend(this.methodBase(this.get), {
                data: query,
                url: '/sub_categories'
            })
        },
        directQuoteRequestServiceabilityGet: function(attrs) {
            return $.extend(this.methodBase(this.get), {
                url: '/businesses/' + attrs.businessId + '/direct_quote_request_serviceability' +
                    '?suburb_id=' + attrs.suburbId + '&sub_category_id=' + attrs.subCategoryId
            })
        },
        businessAIAssistanceCreate: function(attrs) {
            return $.extend(this.apiProcessData(this.post, 'ai_assistance', attrs), {
                url: '/businesses/ai_assistance'
            })
        },
        usersEmailPreferencesUpdate: function(attrs) {
            return $.extend(this.apiProcessData(this.patch, 'emailPreferences', attrs), {
                url: '/users/update_email_preferences/'
            })
        }
    }
}

export default API
